import { withApollo } from '@apollo/client/react/hoc'
import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import { renderSuccessNotification } from 'store/notificationHandler/actions'
import { getSelectedOrdersIds } from 'store/orderList/selectors'
import {
  getAppliedFilters,
  getSearchFilter,
} from 'store/orderListFilters/selectors'

import ChangeSalesRepModal from './ChangeSalesRepModal.component'
import { withUpdateOrderSalesRepMutation } from './ChangeSalesRepModal.mutations'

const mapStateToProps = (state) => ({
  selectedOrderIds: getSelectedOrdersIds(state),
  appliedFilters: getAppliedFilters(state),
  searchFilter: getSearchFilter(state),
})

const mapDispatchToProps = {
  renderSuccessNotification,
}

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  withApollo,
  withUpdateOrderSalesRepMutation,
)(ChangeSalesRepModal)
